import { Injectable, signal } from '@angular/core';
import {environment as env, environment} from "../../environments/environment";
import {Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import { StorageService } from '../shared/services/storage.service';
import { HttpService } from '../shared/services/http.service';
import { 
  API_LOGIN, 
  API_PROFILE, 
  API_UPDATE_PASSWORD, 
  API_FORGOT_PASSWORD, 
  API_LOGOUT 
} from "../shared/constants/constants";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private isAuthenticated: boolean = false;
  private HTTPheaders;

  private readonly _isAdmin = signal<boolean>(false);
  readonly isAdmin = this._isAdmin.asReadonly();

  constructor(
      private router: Router,
      private http: HttpClient,
      private storageService: StorageService,
      private httpService: HttpService
  ) {
    this.HTTPheaders = {
      'Content-Type': 'application/json',
    };

    const user = this.storageService.getFromLocalOrSessionStorage('user');
    if (user) {
      this._isAdmin.set(!!user.is_admin);
    }
  }

  setUserData(user: { email: string; token: string; is_admin: boolean; role: string }, rememberMe: boolean): void {
    if (rememberMe) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      sessionStorage.setItem('user', JSON.stringify(user));
    }
    this._isAdmin.set(!!user.is_admin);
  }

  login(email: string, password: string): Observable<object> {
    const body = { email, password };
    return this.http.post(env.baseUrl + API_LOGIN, body, this.httpService.getOptions(this.HTTPheaders));
  }

  logout(): void {
    this.isAuthenticated = false;
    this._isAdmin.set(false);
    this.storageService.clearStorage();
    this.router.navigate(["/auth/login"]);
  }

  getUserProfile(): Observable<any> {
    return this.http.get<any>(env.baseUrl + API_PROFILE);
  }

  updateProfile(request: any): Observable<any> {
    return this.http.post<any>(env.baseUrl + API_PROFILE, request);
  }

  changePassword(request: any): Observable<object> {
    return this.http.put(
      env.baseUrl + API_UPDATE_PASSWORD,
      request,
      this.httpService.getOptions(this.HTTPheaders)
    );
  }

  resetPassword(request: any): Observable<object> {
    return this.http.post(
      env.baseUrl + API_FORGOT_PASSWORD,
      request,
      this.httpService.getOptions(this.HTTPheaders)
    );
  }

  logOutApi(): Observable<object> {
    return this.http.post(
        env.baseUrl + API_LOGOUT,
        this.httpService.getOptions(this.HTTPheaders)
    );
  }

  getUser() {
    return this.storageService.getFromLocalOrSessionStorage('user')!;
  }

  getRole() {
    const user = this.getUser();
    return user ? user.role : 'User undefined';
  }

  private getOptions() {
    const language = this.storageService.getFromLocalOrSessionStorage('language') || environment.defaultLanguage;
    const headers = ({
      'Content-Type': 'application/json',
      'Language-Locale': language
    });
    return  ({
      headers
    })
  }

}
